import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddEditDiscountsComponent } from './components/add-edit-discounts/add-edit-discounts.component';
import { ListDiscountsComponent } from './components/list-discounts/list-discounts.component';
import { SharedModule } from '../shared/shared.module';
import { EmployeeDiscountsRoutingModule } from './employee-discounts-routing.module';
import { AdminEmployeeDiscountsComponent } from './components/admin-employee-discounts/admin-employee-discounts.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AddEditDiscountsComponent,
    ListDiscountsComponent,
    AdminEmployeeDiscountsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    EmployeeDiscountsRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports:[
    ListDiscountsComponent,
    AddEditDiscountsComponent
  ]
})
export class EmployeeDiscountsModule { }
